import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledRoomPovBox = styled.div<{ isDarkMode: boolean }>`
  padding: 1.8rem;
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.secondary.light : theme.colors.grey[100])};
  margin-bottom: 1.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledEmptyStateText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledSelectedTagsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledPovTag = styled.span<{ label: string }>`
  padding: 0.7rem 1.2rem;
  background-color: ${({ theme, label }) => (label === 'Blue' ? theme.colors.info.lightest : 'rgba(235, 0, 55, 0.2)')};
  color: ${({ theme, label }) => (label === 'Blue' ? theme.colors.info.main : 'rgba(235, 0, 55, 1)')};
  border-radius: ${({ theme }) => theme.radius.huge};
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const StyledCrossIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  color: ${({ theme }) => theme.colors.text.selectionBox};
  margin-left: 0.4rem;
`;

export const StyledTagDismiss = styled.button``;
